import { Action } from '@ngrx/store';
import { AccessRequest } from '@model';

export enum AccessRequestsActionTypes {
    MyAccessRequestsLoad = '[My AccessRequests] Load data',
    MyAccessRequestsLoadSuccess = '[My AccessRequests] Load success',
    MyAccessRequestsLoadFail = '[My AccessRequests] Load fail',
    MyAccessRequestsRemove = '[My AccessRequests] Remove access request',
    MyAccessRequestsRemoveSuccess = '[My AccessRequests] Remove access request success',
    MyAccessRequestsRemoveFail = '[My AccessRequests] Remove access request fail'
}

export class MyAccessRequestsLoad implements Action {
    readonly type = AccessRequestsActionTypes.MyAccessRequestsLoad;
    constructor() {}
}

export class MyAccessRequestsLoadSuccess implements Action {
    readonly type = AccessRequestsActionTypes.MyAccessRequestsLoadSuccess;
    constructor(public payload: AccessRequest[]) {}
}

export class MyAccessRequestsLoadFail implements Action {
    readonly type = AccessRequestsActionTypes.MyAccessRequestsLoadFail;
    constructor(public payload: any) {}
}

export class MyAccessRequestsRemove implements Action {
    readonly type = AccessRequestsActionTypes.MyAccessRequestsRemove
    constructor(public payload: AccessRequest) {}
}

export class MyAccessRequestsRemoveSuccess implements Action {
    readonly type = AccessRequestsActionTypes.MyAccessRequestsRemoveSuccess
    constructor(public payload: number) {}
}

export class MyAccessRequestsRemoveFail implements Action {
    readonly type = AccessRequestsActionTypes.MyAccessRequestsRemoveFail
    constructor(public payload: any) {}
}

export type AccessRequestsActions =
    | MyAccessRequestsLoad
    | MyAccessRequestsLoadSuccess
    | MyAccessRequestsLoadFail
    | MyAccessRequestsRemove
    | MyAccessRequestsRemoveSuccess
    | MyAccessRequestsRemoveFail;